import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate', pure: true, standalone: false  })
export class TruncatePipe implements PipeTransform {
  transform(value: unknown, len = 30): string {
    if (value == null) return '';
    const s = String(value);
    return s.length > len ? s.slice(0, len - 1) + '…' : s;
  }
}
